export const GeocodeApiKey = () => {
  return "AIzaSyALtI2PTcWdaSheRdGlki3jAHnyaMlnT6Q";
};

export const RecaptchaApiKey = () => {
  return "6LcK5SIcAAAAANfJ3AjkJN4sQPrwQKDAzBnlsulb";
};
